// extracted by css-extract-rspack-plugin
export default {"container":"Gtztw58BfLcKuuI_"};